import { Component, OnInit, HostListener } from '@angular/core';
import { Spinkit } from 'ng-http-loader';
import { BaseUrl } from './framework/constants/url-constants';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { RoutePartsService } from './framework/service/route-parts.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  appTitle = BaseUrl.APPTITLE;
  public spinkit = Spinkit;
  pageTitle = '';
  isMobile = false;
  forceDesktopView = false;

  private readonly desktopViewStorageKey = 'forceDesktopView';
  private readonly mobileBreakpointPx = 768;

  constructor(
    public title: Title,
    private readonly router: Router,
    private readonly routePartsService: RoutePartsService,
    private readonly activeRoute: ActivatedRoute,
  ){

  }
  ngOnInit() {
    this.setInitialData();
    this.loadDesktopViewPreference();
    this.updateViewportMode();
    this.changePageTitle();
  }

  get showMobileBlocker(): boolean {
    return this.isMobile && !this.forceDesktopView;
  }

  @HostListener('window:resize')
  onResize() {
    this.updateViewportMode();
  }

  enableDesktopView() {
    this.forceDesktopView = true;
    try {
      localStorage.setItem(this.desktopViewStorageKey, 'true');
    } catch {
      // ignore storage failures
    }
  }

  private loadDesktopViewPreference() {
    try {
      this.forceDesktopView = localStorage.getItem(this.desktopViewStorageKey) === 'true';
    } catch {
      this.forceDesktopView = false;
    }
  }

  private updateViewportMode() {
    // Guard for SSR / non-browser contexts.
    const width = typeof window !== 'undefined' ? window.innerWidth : this.mobileBreakpointPx;
    this.isMobile = width < this.mobileBreakpointPx;

    if (this.isMobile && !this.forceDesktopView) {
      this.loadDesktopViewPreference();
    }
  }
  
  changePageTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
      const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      if (!routeParts.length) {
        return this.title.setTitle(this.appTitle);
      }

      routeParts.reverse();
      this.pageTitle = routeParts
        .map((part) => part.title)
        .reduce((partA, partI) => `${partI}`);
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    });
  }

  setInitialData() {
        localStorage.setItem('clientId', '9');
        localStorage.setItem('ApplicationID', '115');
  }
}
